import { JSX } from 'react';
import {
    Datagrid,
    DateField,
    DateInput,
    List,
    ReferenceField,
    SelectInput,
    TextField,
    TextInput,
} from 'react-admin';

const activityCategories: { id: string, name: string }[] = [
    { id: 'account', name: 'Account' },
    { id: 'security', name: 'Security' },
    { id: 'subscription', name: 'Subscription' },
    { id: 'organization', name: 'Organizations' },
    { id: 'toolbox', name: 'Toolbox' },
    { id: 'contacts', name: 'Contacts' },
    { id: 'users', name: 'Users' },
];

const activityFilters: JSX.Element[] = [
    <SelectInput key="category" source="category" label="Category" choices={ activityCategories } alwaysOn />,
    <TextInput key="type" source="type" label="Event type" />,
    <TextInput key="account" source="customerAccount.id" label="Account ID" />,
    <DateInput key="after" source="createdAt[after]" label="From" />,
    <DateInput key="before" source="createdAt[before]" label="To" />,
];

/**
 * Every account's activity in one place, for looking across accounts rather than at one.
 * The per-account view is the Activity tab on the customer account edit screen.
 *
 * There is no create, edit or delete: the resource exposes Get and GetCollection only, so the
 * trail cannot be rewritten from the admin either.
 */
export const CustomerActivityMonitorList: () => JSX.Element = (): JSX.Element => (
    <List
        filters={ activityFilters }
        sort={ { field: 'createdAt', order: 'DESC' } }
        perPage={ 50 }
        exporter={ false }
    >
        <Datagrid bulkActionButtons={ false } rowClick={ false }>
            <DateField source="createdAt" label="When" showTime />
            <ReferenceField
                source="customerAccount"
                reference="customer_accounts"
                label="Account"
                link="edit"
            >
                <TextField source="id" />
            </ReferenceField>
            <TextField source="category" label="Category" sx={ { textTransform: 'capitalize' } } />
            <TextField source="typeLabel" label="Action" />
            <TextField source="actorName" label="Who" />
            <TextField source="actorRoleLabel" label="Role" />
            <TextField source="subjectLabel" label="Subject" />
        </Datagrid>
    </List>
);
